import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import 'semantic-ui-css/semantic.min.css'
import * as styles from './styles/layout.module.css'
import Auth from 'aws-amplify'
import config from '../../aws-cognito'
Auth.configure(config)
//arrow prop just in case we want to make this selectively appear only on certain pages
const Layout = ({location, loggedIn, children, backButton}) => {


	return (
		<>
			<div className={styles.header}>
				<Header location={location} loggedIn={loggedIn} arrow={backButton}/>
			</div>
			<div className={styles.content}>
				{children}
			</div>
			<Footer />
		</>
	)
}

Layout.defaultProps = {
	backButton: false,
}
export default Layout

